import _ from 'lodash';

import ProductRewardListItem from '../entity/ProductRewardListItem';
import { Maybe, OfferPricingDetailItem } from '../graphql/generated/graphql';

export type OfferPricingDetails = Maybe<{
  basicPricings: Pick<OfferPricingDetailItem, 'itemType' | 'rewardAmount' | 'rewardCurrency' | 'amount'>[];
  optionPricings: Pick<
    OfferPricingDetailItem,
    'itemType' | 'rewardAmount' | 'itemGroupName' | 'itemGroupKey' | 'rewardCurrency' | 'amount'
  >[];
}>;
export type ModificationRequests = Maybe<
  {
    offerPricingDetail?: Maybe<{
      basicPricings: Pick<OfferPricingDetailItem, 'amount' | 'rewardAmount' | 'rewardCurrency'>[];
      optionPricings: Pick<OfferPricingDetailItem, 'amount' | 'rewardAmount'>[];
    }>;
  }[]
>;

export function createRewardListData(
  offerPricingDetails: OfferPricingDetails,
  modificationRequests: ModificationRequests,
) {
  const rewardList: [ProductRewardListItem[]] = [[]];

  // get basic reward list
  rewardList.push(productOptionRewardList('new', offerPricingDetails, modificationRequests));
  rewardList.push(productOptionRewardList('option', offerPricingDetails, modificationRequests));
  rewardList.push(productOptionRewardList('express', offerPricingDetails, modificationRequests));
  rewardList.push(productOptionRewardList('modification', offerPricingDetails, modificationRequests));

  return rewardList;
}

// create reward list
function productOptionRewardList(
  action: string,
  offerPricingDetails: OfferPricingDetails,
  modificationRequests: ModificationRequests,
  times = 1,
) {
  const rewardList: ProductRewardListItem[] = [];

  if (action === 'new') {
    const basicPrice = offerPricingDetails?.basicPricings.find((price) => price?.itemType === 'new');
    if (basicPrice === null || basicPrice === undefined) {
      return [];
    }
    rewardList.push({
      categoryName: action,
      itemName: null,
      itemKey: null,
      rewardCurrency: basicPrice.rewardCurrency,
      rewardAmount: basicPrice.rewardAmount,
      quantity: basicPrice.amount,
      times: times,
    });
  }

  if (action === 'option' && offerPricingDetails) {
    const optionPrice = offerPricingDetails.optionPricings.filter(
      (price) => price && price.itemType !== 'express' && price.itemType !== 'modification' && price.rewardAmount > 0,
    );
    optionPrice.forEach((price) => {
      rewardList.push({
        categoryName: null,
        itemName: price.itemGroupName || null,
        itemKey: price.itemGroupKey || null,
        rewardCurrency: price.rewardCurrency,
        rewardAmount: price.rewardAmount,
        quantity: price.amount,
        times: times,
      });
    });
  }

  if (action === 'express' && offerPricingDetails) {
    const expressBasicPrice = offerPricingDetails.basicPricings.filter((price) => price?.itemType === 'express');
    const expressOptionPrice = offerPricingDetails.optionPricings.filter((price) => price?.itemType === 'express');

    const expressPrice = _.concat(expressBasicPrice, expressOptionPrice);
    let extpressAmount = 0;
    if (expressPrice.length === 0) return [];

    expressPrice.forEach((price) => {
      extpressAmount += price.rewardAmount * price.amount;
    });
    if (extpressAmount > 0) {
      rewardList.push({
        categoryName: action,
        itemName: '',
        itemKey: null,
        rewardCurrency: expressBasicPrice[0].rewardCurrency || 'JPY',
        rewardAmount: extpressAmount,
        quantity: 1,
        times: times,
      });
    }
  }

  if (action === 'modification' && modificationRequests) {
    modificationRequests.forEach((modificationRequest) => {
      if (modificationRequest && modificationRequest.offerPricingDetail) {
        let sumAmount = 0;
        modificationRequest.offerPricingDetail.basicPricings.forEach((basicPricing) => {
          sumAmount += basicPricing.rewardAmount * basicPricing.amount;
        });
        modificationRequest.offerPricingDetail.optionPricings.forEach((optionPricing) => {
          sumAmount += optionPricing.rewardAmount * optionPricing.amount;
        });

        rewardList.push({
          categoryName: action,
          itemName: '',
          itemKey: null,
          rewardCurrency: modificationRequest.offerPricingDetail.basicPricings[0].rewardCurrency,
          rewardAmount: sumAmount,
          quantity: 1,
          times: times,
        });
      }
    });
  }
  return rewardList;
}
